import { createSelector } from 'reselect';
import { createModuleStateSelector } from '@americanexpress/travel-selectors';
import { ROOT_MODULE_NAME } from '../constants/modules';

const getRootModuleStateSelector = createModuleStateSelector(ROOT_MODULE_NAME);

export const getPrefetchedExperimentsSelector = createSelector(
  getRootModuleStateSelector,
  (state) => state?.getIn(['experiments', 'prefetchedExperiments'])
);
